<div class="vs-homepage-overlay" #rolesOverlay>
    <span class="overlay-txt">
        <em class="material-icons custom-close" (click)="closeRolesMatrixOverlay();">close</em>
    </span>
</div>

<div class="roles-container" #containerDesc>
    <div class="role-matrix-txt">{{ "myProfile.roleMatrix" | cxTranslate }}</div>
   <img src="../../../../../../../assets/img/rolesmatrix.png" alt="roles" />
</div>